import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconYoutubeLogoFilled = generateIcon({
  name: 'YoutubeLogoFilled',
  path: (
    <>
      <g clipPath="url(#clip0_3814_710)">
        <path d="M26.9414 6.58545C28.1469 6.90813 29.0942 7.85545 29.4169 9.06092H29.4146C30 11.2437 30 15.8005 30 15.8005C30 15.8005 30 20.3573 29.4146 22.54C29.0919 23.7455 28.1445 24.6928 26.9391 25.0155C24.7563 25.6009 16 25.6009 16 25.6009C16 25.6009 7.24366 25.6009 5.06092 25.0155C3.85545 24.6928 2.90813 23.7455 2.58545 22.54C2 20.3573 2 15.8005 2 15.8005C2 15.8005 2 11.2437 2.58545 9.06092C2.90813 7.85545 3.85545 6.90813 5.06092 6.58545C7.24366 6 16 6 16 6C16 6 24.7563 6 26.9414 6.58545ZM20.4761 15.8005L13.1995 11.6009V20L20.4761 15.8005Z" />
      </g>
      <defs>
        <clipPath id="clip0_3814_710">
          <rect width="28" height="19.6009" fill="white" transform="translate(2 6)" />
        </clipPath>
      </defs>
    </>
  ),
});
